<template>
  <div v-tooltip="{content: tooltip, trigger: triggerMethod}" class="badge" :style="!completed? 'opacity: 0.09':''">
    <i class="fa-solid" :class="icon" style="position: relative" :style="{'fontSize': scale+'em'}" v-if="!completed"></i>
    <i class="fa-duotone softTextShadow" :class="icon" style="position: relative; --fa-secondary-opacity: 1.0" :style="{'--fa-primary-color' : color1, '--fa-secondary-color': color2, 'fontSize': scale+'em'}" v-else></i>
    <span class="blend-mode mediumShadow" :style="completed? 'background-color: '+ (inverse?color2:color1)+ '; color: '+ (inverse?color1:color2) +'; font-weight:bold':''" v-if="number!=0">{{number}}</span>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "badge",
  props:{
    tooltip:{default:''},
    number:{default:0},
    color1:{default:'hsl(32, 50%, 10%)'},
    color2:{default:'#555555'},
    inverse:{default:false},
    scale:{default:1},
    icon:{},
    completed:{default:false},

    badgeId: Number
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    triggerMethod: function() {
      if(this.isMobile) {
        return 'click'
      }
      return 'hover'
    }
  }
}
</script>

<style scoped>
  .badge{
    font-size: 2.2vw;
    position: relative;
    margin-top: 0.25vw;
  }

  .blend-mode {
    /*background:white;*/
    position: absolute;
    display: flex;
    justify-content: center;
    text-align: center;
    right: -0.7vw;
    top: 0.25vw;
    min-width: 1vw;
    font-size: 0.7vw;
    font-weight: bold;
    border-radius: 2vw;
    padding: 0.1vw 0.2vw 0.1vw 0.2vw;
    background-color: hsl(220, 60%,70%);
    color: var(--navBackgroundColor);
  }


  @media screen and (max-device-width: 767px) {
    .badge{
      font-size: 9vw;
      position: relative;
      margin-top: 1vw;
    }
    .blend-mode {
      right: -4vw;
      top: 0.5vw;
      min-width: 4vw;
      font-size: 3.5vw;
      font-weight: bold;
      border-radius: 8vw;
      padding: 0.8vw 1.6vw 0.8vw 1.6vw;
    }
  }
</style>